import { render, staticRenderFns } from "./MyTabs.vue?vue&type=template&id=0ad089e4&scoped=true&"
import script from "./MyTabs.vue?vue&type=script&lang=ts&"
export * from "./MyTabs.vue?vue&type=script&lang=ts&"
import style0 from "./MyTabs.vue?vue&type=style&index=0&id=0ad089e4&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad089e4",
  null
  
)

export default component.exports